import { createToaster } from '@chakra-ui/react';

export const toasterTop: ReturnType<typeof createToaster> = createToaster({
  placement: 'top',
  max: 5,
  pauseOnPageIdle: true,
});

export const toaster: ReturnType<typeof createToaster> = createToaster({
  placement: 'bottom',
  max: 5,
  pauseOnPageIdle: true,
});
